import { render } from "./TotalAndSplit.vue?vue&type=template&id=e6c87948&ts=true"
import script from "./TotalAndSplit.vue?vue&type=script&lang=ts"
export * from "./TotalAndSplit.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__